import { render, staticRenderFns } from "./CollegeScoreLine.vue?vue&type=template&id=b2f57626&scoped=true&"
import script from "./CollegeScoreLine.vue?vue&type=script&lang=js&"
export * from "./CollegeScoreLine.vue?vue&type=script&lang=js&"
import style0 from "./CollegeScoreLine.vue?vue&type=style&index=0&id=b2f57626&scoped=true&lang=less&"
import style1 from "./CollegeScoreLine.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f57626",
  null
  
)

export default component.exports